import { OrderDeliveryConfirmationEnum } from '@ztechapps/common.contract'

export const OrderDeliveryConfirmation = {
  signature: {
    value: OrderDeliveryConfirmationEnum.signature,
    description:
      'Signature is required for the shipment to be delivered; this signature may be a neighbor, building manager, or the recipient can authorize the release of the package (without being present).',
  },
  delivery: {
    value: OrderDeliveryConfirmationEnum.delivery,
    description: 'Delivery confirmation is requested.',
  },
  none: {
    value: OrderDeliveryConfirmationEnum.none,
    description: 'No confirmation requested.',
  },
}
